import { Component, OnInit, Input } from '@angular/core';
import { HelperActions } from 'src/app/helpers/helper-actions';
import { StaticData } from 'src/app/helpers/static-data';
import { ControlActions } from 'src/app/models/general.enum';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { Utilities } from 'src/app/helpers/utilities';

@Component({
  selector: 'app-doc-viewer',
  templateUrl: './doc-viewer.component.html',
  styleUrls: ['./doc-viewer.component.scss']
})
export class DocViewerComponent implements OnInit {

  @Input() isDesigner: boolean = false;
  @Input() url: string = null;
  @Input() isImage: boolean = false;
  @Input() isVideo: boolean = false;
  @Input() isAudio: boolean = false;
  @Input() isOffice: boolean = false;
  @Input() isPdf: boolean = false;

  @Input() viewerType: string = StaticData.OfficeViewer ? "office" : "google";
  @Input() config: any;
  @Input() modelo: any;
  @Input() permissionsConfig: any;
  @Input() item: any;
  verAlerta: boolean = false;
  @Input() nameDocument: string = null;
  @Input() documentInfo: any = null;
  @Input() componentName: string = 'TDocumentoExpediente';
  esHabeasData: boolean = false;
  cargandoHabeasData: boolean = false;
  constructor(
    public helperActions: HelperActions,
    private baseService: BaseServiceService,
    private utility: Utilities
  ) { }

  //* FUNCIONES ANGULAR
  ngOnInit() {
  //debugger;
    this.Init();

  }
  SetExtensionesImagen(extension: string) {
    this.isImage = (extension == "png" || extension == "jpg" || extension == "jpeg" || extension == "gif");
    if (this.isImage)
      //document.oncontextmenu = function(){return false}
      $(document).ready(function () {

        //Disable part of page
        $(".imagenMostrar").on("contextmenu",function(e){
            return false;
        });
    });

    $(document).on('dragstart', 'img', function(evt) {
      evt.preventDefault();
    });
  }
  SetExtensionesVideo(extension: string) {
    this.isVideo = (extension == "mp4" || extension == "ogv" || extension == "webm" || extension == "avi" || extension == "divx" || extension == "mov" || extension == "mpg" || extension == "mkv" || extension == "wmv" || extension == "wpl");
  }
  SetExtensionesAudio(extension: string) {
    this.isAudio = (extension == "mp3" || extension == "ogg" || extension == "wav" || extension == "opus" || extension == "wma" || extension == "flac" || extension == "midi" || extension == "m3u");
  }
  SetExtensionesOffice(extension: string) {
    this.isOffice = (extension == "ppt" || extension == "pptx" || extension == "doc" || extension == "docx" || extension == "xls" || extension == "xlsx");
    //Para TipoUbicacion 'FileSystem' comentar lineas de abajo, el visor de office no funciona, en cambio dejar
    //viewerType = "google"; que viene por defecto (en el visor de goole si se puede ver el archivo)
    /**
     * Inicio Edward Morales 02022024
     * Ajuste provisional por conflicto de seguridad SSL y Dominio
     *
     * Se realizaron validaciones con viso de office, solo permite visualizar documentos office
     * si el origen tiene certificado SSL y/o Dominio, de lo contrario no permite
     * los demás documentos por no tener extensión office entrar a visor de google para su respectiva
     * visualización.
     */
    if (this.isOffice)
      this.viewerType =  StaticData.OfficeViewer ? "office" : "google";
  }
  SetExtensionesPDF(extension: string) {
    this.isPdf = (extension == "pdf");

    if (this.isPdf && this.viewerType != "Preview")
      this.viewerType = "pdf";
  }
  SetExtension() {
    if (this.url) {
      const extension: string = this.url.substring(this.url.lastIndexOf('.') + 1).toLowerCase();
      this.SetExtensionesImagen(extension);
      if (!this.isImage) {
        this.SetExtensionesPDF(extension)
        if (!this.isPdf)
          this.SetExtensionesVideo(extension);
        if (!this.isVideo)
          this.SetExtensionesAudio(extension)
        if (!this.isAudio)
          this.SetExtensionesOffice(extension)
      }
    }
    if (!this.isImage && this.nameDocument) {
      const extension: string = this.nameDocument.substring(this.nameDocument.lastIndexOf('.') + 1).toLowerCase();
      this.SetExtensionesImagen(extension);
      if (!this.isImage) {
        this.SetExtensionesPDF(extension)
        if (!this.isPdf)
          this.SetExtensionesVideo(extension);
        if (!this.isVideo)
          this.SetExtensionesAudio(extension)
        if (!this.isAudio)
          this.SetExtensionesOffice(extension)
      }
    }
  }
  DeleteUrl() {
    this.url = null;
  }
  height = "";
  width = "";
  public Init() {
    if (this.config) {

      if (!this.config.Style)
        this.config.Style = {};
      if (Object.keys(this.config.Style).length == 0) {
        this.config.Style["width"] = "100%";
        this.config.Style["height"] = "93vh";
      }

      this.height = this.config.Style["height"];
      this.width = this.config.Style["width"];
      if (this.config.Url)
        this.url = this.config.Url;

      if (this.config.ViewerType)
        this.viewerType = this.config.ViewerType;

    }

    this.SetExtension();

    // Verificar si el documento tiene Habeas Data
    this.VerificarHabeasData();

    if (this.item)
      this.View();
    else

      this.VerAlert();
  }

  VerificarHabeasData() {
    this.esHabeasData = false;
    //debugger;
    // Verificar si documentInfo existe y tiene IdDocumentoExpediente
    if (this.documentInfo && this.documentInfo.IdDocumentoExpediente) {
      this.cargandoHabeasData = true;
      
      // Consultar el SP ConsultaTipoDatoDocumentoCombo
      let obj = this.utility.GetApiModel('ConsultaTipoDatoDocumentoCombo', null);
      obj.QueryConfig = {
        Command: 'ConsultaTipoDatoDocumentoCombo',
        IsSp: true,
        Entity: {
          IdEmpresa: StaticData.Usuario.IdEmpresa,
          IdDocumentoExpediente: this.documentInfo.IdDocumentoExpediente,
          Activo: 1,
          IdUsuario: StaticData.Usuario.IdUsuario,
          IdRole: StaticData.Usuario.IdRole,
          Imei: StaticData.Usuario.Imei,
          CodigoUsuario: StaticData.Usuario.Codigo,
          CodigoRole: StaticData.Usuario.CodigoRole,
          CodigoGrupo: StaticData.Usuario.CodigoGrupo,
          CodigoAreaEmpresa: StaticData.Usuario.CodigoAreaEmpresa,
          TodosPermisosExpedientes: StaticData.Usuario.TodosPermisosExpedientes,
          TodosPermisosDocumentosExpedientes: StaticData.Usuario.TodosPermisosDocumentosExpedientes,
          EsMultiempresa: StaticData.GeneralConfig.EsMultiempresa ? 1 : 0,
          IdTipoBusquedaAreaEmpresa: StaticData.Usuario.IdTipoBusquedaAreaEmpresa
        }
      };

      let info = {
        componentName: this.componentName,
        controlName: 'ConsultaTipoDatoDocumentoCombo',
        processMessage: 'Verificando permisos del documento...'
      };

      this.baseService.Get(obj, null, info, this.componentName, false, false).then(data => {
        this.cargandoHabeasData = false;
        
        // El SP retorna: IdTipoDatoDocumento, Nombre, EsHabeasData
        if (data && data.Data && data.Data.length > 0) {
          //Filtra data con el id this.documentInfo.IdTipoDatoDocumento
          const tipoDatoDocumento = data.Data.filter(item => item.IdTipoDatoDocumento === this.documentInfo.IdTipoDatoDocumento);
          
          // Verificar que el filtro encontró resultados antes de acceder al primer elemento
          if (tipoDatoDocumento.length > 0) {
            // Verificar si EsHabeasData es true (puede venir como 1 o true)
            if (tipoDatoDocumento[0].EsHabeasData === true || 
                tipoDatoDocumento[0].EsHabeasData === 1 ||
                tipoDatoDocumento[0].EsHabeasData === true ||
                tipoDatoDocumento[0].EsHabeasData === 1) {
              this.esHabeasData = true;
            }
          }
        }
      }).catch(err => {
        this.cargandoHabeasData = false;
        this.utility.logger.LogError(err, {});
        // En caso de error, por seguridad, se puede dejar en false o true según la política
        // this.esHabeasData = false;
      });
    }
    // Si no hay IdDocumentoExpediente, verificar en la estructura del objeto directamente
    else if (this.documentInfo) {
      if (this.documentInfo.TipoDatoDocumento) {
        if (this.documentInfo.TipoDatoDocumento.EsHabeasData === true || 
            this.documentInfo.TipoDatoDocumento.EsHabesData === true ||
            this.documentInfo.TipoDatoDocumento.EsHabeasData === 1 ||
            this.documentInfo.TipoDatoDocumento.EsHabesData === 1) {
          this.esHabeasData = true;
        }
      }
      else if (this.documentInfo.EsHabeasData === true || 
               this.documentInfo.EsHabesData === true ||
               this.documentInfo.EsHabeasData === 1 ||
               this.documentInfo.EsHabesData === 1) {
        this.esHabeasData = true;
      }
    }
  }
  OnChangeHeight() {
    this.config.Style["height"] = this.height;
  }
  OnChangeWidth() {
    this.config.Style["width"] = this.width;
  }

  OnChangeViewerType() {
    this.viewerType = this.config.ViewerType;
  }
  VerAlert() {
    if (!this.url) {
      this.verAlerta = true;
    }
    else
      this.verAlerta = false;
  }
  //* END FUNCIONES ANGULAR

  View() {
    //ControlActions

    let action = { ComponentName: this.config.Controller };

    let option = {};
    this.helperActions.DownloadFile(action, option, this.item, this, null, null, null, ControlActions.ViewDocument, null, {});

    // setTimeout(() => {
    //
    //   this.url = "https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.doc";//"http://localhost:58205/TempDocs/PLANTILLA_FINLA_EXPEDIENTE.docx";
    //   this.VerAlert();
    // }, 500);

  }
  // Imprmir documentos desde visor
  printDocument() {
    if (this.viewerType == 'office') {
      const fullUrl = 'https://view.officeapps.live.com/op/embed.aspx?src='+ encodeURIComponent(this.url) +'&type=printpdf&useNamedAction=1'; // sin embedded=true
      window.open(fullUrl, '_blank', 'width=800,height=600,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');
    } else if (this.isImage) {
      const ventana = window.open('', '_blank', 'width=800,height=600');
      if (ventana) {
        ventana.document.write(`
          <html>
            <head>
              <title>Imprimir imagen</title>
              <style>
                body { margin: 0; text-align: center; }
                img { max-width: 100%; max-height: 100vh; }
              </style>
            </head>
            <body onload="window.print(); window.close();">
              <img src="${this.url}" alt="Imagen a imprimir" />
            </body>
          </html>
        `);
        ventana.document.close();
      }
    } else {
      const fullUrl = 'https://docs.google.com/gview?url='+ encodeURIComponent(this.url) +'&embedded=false'; // sin embedded=true
      window.open(fullUrl, '_blank', 'width=800,height=600,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');
    }
  }
}
